import React from "react";
import "./descss.css"; // Import a separate CSS file for styling

export default function Description() {
  return (
    <div className="text-center p-5">
      <h1 className="mb-4 font-weight-bold title-effect" style={{
                    userSelect: "none", 
                    pointerEvents: "none",
                }}>Fresh. Nutritious. Yours. Welcome to The Dry Fruit Shop</h1>
      <p className="lead text-effect" style={{
                    userSelect: "none", 
                    pointerEvents: "none",
                }}>
        Indulge in a symphony of flavors at our one-stop destination, offering exquisite dry fruits, premium dates, and personalized dry fruit baskets. Immerse yourself in the natural sweetness and wholesome goodness of our curated selection of Kashmiri dry fruits, featuring luscious dates and an array of nuts. At The Dry Fruit Shop, we prioritize quality and customer satisfaction. Explore the richness of nature with us and let your taste buds savor the delight!
      </p>
   
    </div>
  );
}
